import { useNavigate } from "react-router-dom";

import { NAV_ITEMS } from "@/lib/nav";

/**
 * ホーム画面（認証後のトップ）。
 *
 * ngtg_msc に準拠し、ブランドカラーの角丸タイルを並べたメニューだけの画面。
 * タイルの定義は lib/nav.ts が単一ソース（ドロワーと共有）。
 */
export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-[1120px] p-4 md:p-8">
      {/* 現状は 3 項目なので 3 列。項目が増えたら列数を増やす。
          タイルは正方形。ngtg_msc（3 列・1440px 幅で約 349px 角）と同程度の
          大きさになるよう、コンテナ幅を 1120px で頭打ちにしている。 */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {NAV_ITEMS.map((item) => (
          <button
            key={item.path}
            type="button"
            onClick={() => navigate(item.path)}
            className="flex aspect-square flex-col items-center justify-center gap-6 rounded-tile bg-brand-500 text-white transition-colors hover:bg-brand-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-700"
          >
            <item.icon className="size-12 md:size-16" strokeWidth={1.5} />
            <span className="text-lg font-bold md:text-2xl">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
